/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const checkPhoneRequestRequestSchema = z.object({
	country_code: z.string().min(1).max(4).optional().default("+7"),
	phone: z.string().min(1).max(20),
});
